/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Biochemistry19Inputs */

const en__field__enum_additionalstudyinterests_study_biochemistry19 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Biochemistry19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biochemistry`)
};

const de__field__enum_additionalstudyinterests_study_biochemistry19 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Biochemistry19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biochemie`)
};

/**
* | output |
* | --- |
* | "Biochemistry" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Biochemistry19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_biochemistry19 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Biochemistry19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Biochemistry19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_biochemistry19(inputs)
	return de__field__enum_additionalstudyinterests_study_biochemistry19(inputs)
});
export { _field__enum_additionalstudyinterests_study_biochemistry19 as "_field__enum_additionalStudyInterests_STUDY_BIOCHEMISTRY" }